(function ($) {
    $.fn.extend({
        initSlide: function (usrConfig) {
            const config = $.extend({
                breakpoints: {
                    xs: [0, 576],
                    sm: [576, 768],
                    md: [768, 992],
                    lg: [992, 1200],
                    xlg: [1200, 100000]
                }
            }, usrConfig);

            const methods = {
                init: function (currentSlide) {
                    let resizeInterval;
                    const windowSize = methods.getWindowSize.call(this);

                    // Bind window resize event
                    $(window).unbind("resize").bind("resize", function () {
                        clearTimeout(resizeInterval);
                        resizeInterval = setTimeout(function () {
                            methods.init.call(this, currentSlide);
                        }, 250);
                    });

                    // Run!
                    methods.setBackgroundImage.call(this, currentSlide, windowSize);
                    methods.setBackgroundSize.call(this, currentSlide);
                    methods.setBackgroundColor.call(this, currentSlide);
                },
                setBackgroundImage: function (currentSlide, windowSize) {

                    // Get background image for current window size
                    let currentIndex = Object.keys(config.breakpoints).indexOf(windowSize);
                    let backgroundImage = methods.getBackgroundImage.call(this, currentSlide, windowSize);

                    // Look for other breakpoints
                    while (backgroundImage === undefined && currentIndex > 0) {
                        windowSize = Object.keys(config.breakpoints)[--currentIndex];
                        backgroundImage = methods.getBackgroundImage.call(this, currentSlide, windowSize);
                    }

                    // Get global background image if still nothing found
                    backgroundImage = backgroundImage !== undefined ? backgroundImage : methods.getBackgroundImage.call(this, currentSlide);

                    if (backgroundImage !== undefined && backgroundImage !== null) {
                        currentSlide.css("background-image", "url(" + backgroundImage + ")");
                    }
                },
                setBackgroundSize: function (currentSlide) {
                    const backgroundSize = currentSlide.attr("data-background-size");

                    if (backgroundSize !== undefined && backgroundSize !== null) {
                        if (["cover", "contain"].indexOf(backgroundSize.toLowerCase()) >= 0) {
                            currentSlide.css("background-size", backgroundSize);
                        }
                    }
                },
                setBackgroundColor: function (currentSlide) {
                    const backgroundColor = currentSlide.attr("data-background-color");

                    if (backgroundColor !== undefined && backgroundColor !== null) {
                        if (methods.validateHex.call(this, backgroundColor) !== null) {
                            currentSlide.css("background-color", backgroundColor);
                        }
                    }
                },
                getWindowSize: function () {
                    let windowSize = null;
                    const windowWidth = window.innerWidth;

                    Object.keys(config.breakpoints).forEach(function (breakpointKey) {
                        const currentBreakpoint = config.breakpoints[breakpointKey];

                        if (Array.isArray(currentBreakpoint) && currentBreakpoint.length === 2) {
                            if (windowWidth >= currentBreakpoint[0] && windowWidth < currentBreakpoint[1]) {
                                windowSize = breakpointKey;
                            }
                        }
                    });

                    return windowSize;
                },
                getBackgroundImage: function (currentSlide, windowSize) {
                    if (windowSize !== undefined && windowSize !== null) {
                        return currentSlide.attr("data-background-" + windowSize + "-image");
                    }

                    return currentSlide.attr("data-background-image");
                },
                validateHex: function (value) {
                    return value.match(/^#(?:[0-9a-fA-F]{3}){1,2}$/g);
                }
            };

            // Init
            methods.init.call(this, $(this));
        }
    });

    $.extend({
        p: function (value, filename) {
            const matchRegex = new RegExp(filename + "(.min)?.js", "i");
            const currentScript = $("script").filter(function () {
                const attrSrc = $(this).attr("src");

                if (attrSrc !== null && attrSrc !== undefined) {
                    return attrSrc.match(matchRegex);
                }

                return false;
            });

            if (currentScript !== null) {
                return currentScript.data(value);
            }

            return null;
        },
        uniqueId: function () {
            return Math.random().toString(36).substr(2, 9);
        },
        getCookie: function (name) {
            const cookiesArray = document.cookie.split(";");

            for (let i = 0; i < cookiesArray.length; i++) {
                const cookieContent = cookiesArray[i].trim();

                if (cookieContent.indexOf(name) === 0) {
                    return cookieContent.substring(name.length, cookieContent.length);
                }
            }

            return null;
        },
        setCookie: function (name, content, expires) {
            const expiresDate = new Date();
            expiresDate.setTime(expiresDate.getTime() + (expires * 24 * 60 * 60 * 1000));

            document.cookie = name + "=" + content + "; expires=" + expiresDate.toUTCString() + "; path=/";
        },
        initBackgroundImage: function () {
            $("*[data-background-image]").each(function () {
                const currentObject = $(this);
                const imageURL = currentObject.data("backgroundImage");

                if (imageURL !== undefined && imageURL !== "") {
                    currentObject.css("background-image", "url(" + imageURL + ")");
                }
            });
        },
        initHover: function () {
            $("*[data-hover]").each(function () {
                const currentObject = $(this);
                const config = currentObject.data("hover");

                // Define hover object
                const hoverObject = config.selector !== undefined ? $(config.selector) : currentObject;

                // Define variable to store source value
                let sourceValue = null;

                // Hover event subscriber
                hoverObject.hover(function () {
                    sourceValue = currentObject.attr(config.attr);
                    currentObject.attr(config.attr, config.value);
                }, function () {
                    currentObject.attr(config.attr, sourceValue);
                });
            });
        },
        initLink: function () {
            $("*[data-link]").bind("click", function () {
                const redirectURL = $(this).data("link");

                if (redirectURL !== null && redirectURL !== undefined && redirectURL !== "") {
                    window.location = redirectURL;
                }
            });
        },
        initNotification: function () {
            $("[data-notification]").each(function () {
                $(this).notificationPlugin({
                    type: $(this).data("notificationType"),
                    text: $(this).data("notification")
                });
            });
        },
        initDataTable: function () {
            $("[data-dt]").DataTable({
                dom: '<"row mg-y-20"<"col-12 col-md-6"l><"col-12 col-md-6"f>>rt<"row"<"col-12 col-md-3"i><"col-12 col-md-9"p>>',
                autoWidth: false,
                responsive: true,
                pagingType: "full_numbers",
                classes: {
                    sFilterInput: "form-control",
                    sLengthSelect: "form-control"
                },
                language: {
                    sEmptyTable: $.i18n("No data available in table"),
                    sInfo: $.i18n("Showing _START_ to _END_ of _TOTAL_ entries"),
                    sInfoEmpty: $.i18n("Showing 0 to 0 of 0 entries"),
                    sInfoFiltered: $.i18n("(filtered from _MAX_ total entries)"),
                    sInfoPostFix: "",
                    sInfoThousands: ",",
                    sLengthMenu: "_MENU_",
                    sLoadingRecords: $.i18n("Loading.."),
                    sProcessing: $.i18n("Processing.."),
                    sSearch: "",
                    searchPlaceholder: $.i18n("Search"),
                    sZeroRecords: $.i18n("No matching records found"),
                    oPaginate: {
                        sFirst: $.i18n("First"),
                        sLast: $.i18n("Last"),
                        sNext: $.i18n("Next"),
                        sPrevious: $.i18n("Previous")
                    },
                    oAria: {
                        sSortAscending: $.i18n(": activate to sort column ascending"),
                        sSortDescending: $.i18n(": activate to sort column descending")
                    }
                }
            });
        },
        initAOS: function () {
            AOS.init({
                once: true
            });
        },
        initConsentBar: function (cookiesPolicy) {
            const consentContainer = $("#cconsent-bar .cc-text");

            if (consentContainer.find("a").length <= 0) {
                const additionalLink = $("<a />").attr("href", cookiesPolicy).text(
                    $.i18n("More information in the Cookies Policy")
                );

                consentContainer.append(additionalLink);
            }
        },
        initAgeGate: function (ageGate) {
            const confirmButton = $("button[data-age-gate-confirm]");
            const refuseButton = $("button[data-age-gate-refuse]");
            const ageGateObject = document.getElementById("ageGate");

            if (ageGateObject !== null) {
                const ageGateModal = new bootstrap.Modal(document.getElementById("ageGate"), {
                    keyboard: false
                });

                // Show modal window when cookie not exist
                if ($.getCookie("agegate") === null && window.location.pathname !== ageGate) {
                    ageGateModal.show();
                }

                // Set cookie and close modal
                confirmButton.bind("click", function () {
                    $.setCookie("agegate", "confirm", 1);
                    ageGateModal.hide();
                });

                // Redirect to age gate landing page
                refuseButton.bind("click", function () {
                    window.location.replace(ageGate);
                });
            }
        },
        initStickyNavbar: function (stickyObject, marginObject) {
            const navbar = $(".navbar");
            const navbarOffset = navbar.offset();

            $(window).bind("scroll", function () {
                if (window.pageYOffset >= navbarOffset.top) {
                    stickyObject.addClass("sticky");
                    marginObject.addClass("mg-b-180");
                } else {
                    stickyObject.removeClass("sticky");
                    marginObject.removeClass("mg-b-180");
                }
            });
        },
        initNbsp: function (selector) {
            $(selector).each(function () {
                let elementContent = $(this).html();
                elementContent = elementContent.replace(/(\s)([\S])[\s]+/g, "$1$2&nbsp;");

                $(this).html(elementContent);
            });
        }
    });
})(jQuery);

$.i18n().load({
    "Copied to the clipboard": "Skopiowano do schowka",
    "No data available in table": "Brak danych do wyświetlenia",
    "Showing _START_ to _END_ of _TOTAL_ entries": "Pozycje od _START_ do _END_ z _TOTAL_ łącznie",
    "Showing 0 to 0 of 0 entries": "Pozycji 0 z 0 dostępnych",
    "(filtered from _MAX_ total entries)": "(filtrowanie spośród _MAX_ dostępnych pozycji)",
    "Show _MENU_ entries": "Pokaż _MENU_ pozycji",
    "Loading..": "Wczytywanie..",
    "Processing..": "Przetwarzanie..",
    "Search": "Szukaj",
    "No matching records found": "Nie znaleziono pasujących pozycji",
    "First": "Pierwsza",
    "Last": "Ostatnia",
    "Next": "Następna",
    "Previous": "Poprzednia",
    ": activate to sort column ascending": ": aktywuj, by posortować kolumnę rosnąco",
    ": activate to sort column descending": ": aktywuj, by posortować kolumnę malejąco",
    "More information in the Cookies Policy": "Więcej informacji w Polityce cookies"
}, "pl");

(function ($) {
    $.fn.eNinja = function (options) {
        const settings = $.extend({
            nameSelector: "data-name",
            domainSelector: "data-domain"
        }, options);

        const objects = {
            currentObject: null
        };

        const methods = {
            /**
             * Initial function
             *
             * @param currentObject
             */
            initModule: function (currentObject) {
                objects.currentObject = currentObject;

                // Read currentObject data
                const currentObjectData = methods.readData.call(this, currentObject);

                // Build email address
                const emailAddress = methods.buildEmail.call(this, currentObjectData);

                // Replace currentObject content
                methods.replaceContent(currentObject, emailAddress);
            },
            readData: function (currentObject) {
                return {
                    name: currentObject.attr(settings.nameSelector),
                    domain: currentObject.attr(settings.domainSelector)
                };
            },
            buildEmail: function (dataObject) {
                return dataObject.name + '@' + dataObject.domain
            },
            replaceContent: function (currentObject, emailAddress) {
                currentObject.addClass('e-ninja--js').text(emailAddress);

                // Check if currentObject is link
                if (currentObject.is('a')) {
                    currentObject.attr('href', 'mailto:' + emailAddress);
                }
            }
        };

        return this.each(function () {
            methods.initModule.call(this, $(this));
        });
    }
})(jQuery);

(function ($) {
    $.fn.mapPlugin = function (options) {
        const settings = $.extend({
            initialCoordinates: [51.975, 19.149],
            initialZoom: 6,
            markerCluster: true,
            fitBounds: true,
            markerConfig: {
                iconURL: null,
                iconSize: null,
                onClick: null
            }
        }, options);

        const objects = {
            currentObject: null,
            currentMap: null,
            currentMarkerCluster: null
        };

        const methods = {
            initPlugin: function (currentObject) {
                objects.currentObject = currentObject;
                objects.currentMap = methods.prepareMap.call(this);
            },
            prepareMap: function () {
                const currentMap = L.map(objects.currentObject.attr("id"), {gestureHandling: true}).setView(settings.initialCoordinates, settings.initialZoom);

                L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
                    attribution: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
                }).addTo(currentMap);

                return currentMap;
            },
            prepareMarker: function (iconURL, iconSize) {
                return L.icon({
                    iconUrl: iconURL !== null && iconURL !== undefined ? iconURL : settings.markerConfig.iconURL,
                    iconSize: iconSize !== null && iconSize !== undefined ? iconSize : settings.markerConfig.iconSize
                });
            }
        };

        this.getMap = function () {
            return objects.currentMap;
        };

        this.geoJSON = function (data) {
            const defaultMarker = methods.prepareMarker.call(this);

            objects.currentMarkerCluster = settings.markerCluster ? L.markerClusterGroup() : L.featureGroup();
            objects.currentMarkerCluster.addLayer(
                L.geoJSON(data, {
                    pointToLayer: function (feature, latlng) {
                        let currentMarker = defaultMarker;

                        // Overwrite marker if current Point has specified another icon
                        if (feature.properties.markerIcon !== null && feature.properties.markerIcon !== undefined) {
                            currentMarker = methods.prepareMarker.call(this, feature.properties.markerIcon);
                        }

                        // Bind Popup to Marker
                        if (feature.properties.popupContent !== null && feature.properties.popupContent !== undefined) {
                            return L.marker(latlng, {icon: currentMarker}).bindPopup(feature.properties.popupContent);
                        }

                        return L.marker(latlng, {icon: currentMarker});
                    },
                    onEachFeature: function (feature, layer) {
                        layer.on("click", function () {
                            if (typeof settings.markerConfig.onClick === "function") {
                                settings.markerConfig.onClick.call(this, feature);
                            }
                        });
                    }
                })
            ).addTo(objects.currentMap);

            if (settings.fitBounds && objects.currentMarkerCluster.getBounds().isValid()) {
                objects.currentMap.fitBounds(objects.currentMarkerCluster.getBounds());
            }
        };

        this.removeMarkers = function () {
            objects.currentMarkerCluster.eachLayer(function (layer) {
                if (layer instanceof L.Marker) {
                    objects.currentMarkerCluster.removeLayer(layer);
                }
            });

            objects.currentMap.removeLayer(objects.currentMarkerCluster);
        };

        return this.each(function () {
            methods.initPlugin.call(this, $(this));
        });
    }
})(jQuery);

(function ($) {
    $.fn.notificationPlugin = function (options) {
        const settings = $.extend({
            text: null,
            type: null,
            theme: "bootstrap-v4",
            timeout: 3000
        }, options);

        const objects = {
            currentObject: null
        };

        const methods = {
            initPlugin: function (currentObject) {
                objects.currentObject = currentObject;

                if (methods.validVariables.call(this)) {
                    settings.type = settings.type.toLowerCase();

                    if (methods.validType.call(this)) {
                        methods.renderNoty.call(this).show();
                        objects.currentObject.remove();
                    }
                }
            },
            validVariables: function () {
                return settings.text && settings.text !== undefined && settings.type && settings.type !== undefined;
            },
            validType: function () {
                return ["alert", "success", "warning", "error", "info", "information"].indexOf(settings.type) !== -1;
            },
            renderNoty: function () {
                return new Noty({
                    type: settings.type,
                    text: settings.text,
                    theme: settings.theme,
                    timeout: settings.timeout,
                    closeWith: ["click"]
                });
            }
        };

        return this.each(function () {
            methods.initPlugin.call(this, $(this));
        });
    }
})(jQuery);

(function ($) {
    $.fn.pointsMapPlugin = function (options) {
        const settings = $.extend(true, {
            initialCoordinates: [51.975, 19.149],
            initialZoom: 6,
            searchInput: null,
            onlinePositionButton: null,
            singleTemplate: "normal",
            markerConfig: {
                iconURL: null,
                iconSize: null
            },
            dataProvider: {
                collectionProviderURL: null,
                singleProviderURL: null,
                regionProviderURL: null,
                cityProviderURL: null,
                pointProviderURL: null,
                nearestBoundsProviderURL: null,
                cityAutocompleteProviderURL: null
            },
            container: {
                regionChoice: null,
                cityChoice: null,
                pointChoice: null,
                pointDetails: null
            },
            translation: {
                "Please choose a province": "Please choose a province",
                "Please choose a city": "Please choose a city",
                "Show on the map": "Show on the map",
                "Unfortunately, there are no points near your location": "Unfortunately, there are no points near your location",
                "Unfortunately, we can not determine your location": "Unfortunately, we can not determine your location"
            }
        }, options);

        const objects = {
            currentObject: null,
            currentMapPlugin: null,
            cityAutocomplete: null
        };

        const methods = {
            initPlugin: function (currentObject) {
                objects.currentObject = currentObject;
                objects.currentMapPlugin = methods.initMap.call(this);

                // Load points collection
                methods.getCollection.call(this, {
                    hideTemporaryClosed: true
                });

                // Render autocomplete container
                methods.renderCityAutocomplete.call(this);

                // Render choice containers
                if (
                    settings.container.regionChoice !== null &&
                    settings.container.cityChoice !== null &&
                    settings.container.pointChoice !== null
                ) {
                    methods.renderRegionChoice.call(this);
                    methods.renderCityChoice.call(this);
                    methods.renderPointChoice.call(this);
                }

                // Bind online position button & search input
                methods.bindOnlinePositionButton.call(this);
                methods.bindSearchInput.call(this);
            },
            initMap: function () {
                return objects.currentObject.mapPlugin({
                    initialCoordinates: settings.initialCoordinates,
                    initialZoom: settings.initialZoom,
                    markerConfig: {
                        iconURL: settings.markerConfig.iconURL,
                        iconSize: settings.markerConfig.iconSize,
                        onClick: function (markerData) {
                            var pointID = markerData.properties.id;

                            settings.container.pointDetails.addClass("map-point-details--loading");
                            methods.sendRequest.call(this, settings.dataProvider.singleProviderURL, {
                                "pointID": pointID,
                                "singleTemplate": settings.singleTemplate
                            }).done(function (responseData) {
                                if (responseData["detailsTemplate"] !== undefined) {
                                    settings.container.pointDetails.html(responseData["detailsTemplate"]);
                                    settings.container.pointDetails.removeClass("map-point-details--loading");

                                    // Render choice containers
                                    if (
                                        settings.container.regionChoice !== null &&
                                        settings.container.cityChoice !== null &&
                                        settings.container.pointChoice !== null
                                    ) {
                                        methods.renderCityChoice.call(this, responseData["regionID"]);
                                        methods.renderPointChoice.call(this, responseData["regionID"], responseData["cityName"]);
                                    }

                                }
                            });
                        }
                    }
                });
            },
            renderCityAutocomplete: function () {
                objects.cityAutocomplete = $("<section class='autocomplete' />").appendTo(
                    settings.searchInput.parent()
                ).hide();
            },
            renderRegionChoice: function () {
                settings.container.regionChoice.html("");
                settings.container.regionChoice.addClass("map-choice--loading");

                methods.sendRequest.call(this, settings.dataProvider.regionProviderURL).done(function (responseData) {
                    $.each(responseData, function (index, value) {
                        settings.container.regionChoice.append(
                            $("<section class='map-choice__item' />").text(value["name"]).bind("click", function () {
                                methods.renderCityChoice.call(this, value["id"]);
                            })
                        );
                    });

                    settings.container.regionChoice.removeClass("map-choice--loading");
                });
            },
            renderCityChoice: function (regionID) {
                settings.container.cityChoice.html("");

                if (regionID !== undefined && regionID !== null) {
                    settings.container.cityChoice.addClass("map-choice--loading");

                    methods.sendRequest.call(this, settings.dataProvider.cityProviderURL, {"regionID": regionID}).done(function (responseData) {
                        $.each(responseData, function (index, value) {
                            settings.container.cityChoice.append(
                                $("<section class='map-choice__item' />").text(value["name"]).bind("click", function () {
                                    methods.renderPointChoice.call(this, regionID, value["name"]);
                                })
                            );
                        });

                        settings.container.cityChoice.removeClass("map-choice--loading");
                    });
                } else {
                    settings.container.cityChoice.append(
                        $("<section class='map-choice__item' />").text(settings.translation["Please choose a province"])
                    );
                }
            },
            renderPointChoice: function (regionID, cityName) {
                settings.container.pointChoice.html("");

                if (regionID !== undefined && regionID !== null && cityName !== undefined && cityName !== null) {
                    settings.container.pointChoice.addClass("map-choice--loading");

                    methods.sendRequest.call(this, settings.dataProvider.pointProviderURL, {
                        "regionID": regionID,
                        "cityName": cityName
                    }).done(function (responseData) {
                        $.each(responseData, function (index, value) {
                            settings.container.pointChoice.append(
                                $("<section class='map-choice__item' />").text(value["name"]).bind("click", function () {

                                    settings.container.pointDetails.addClass("map-point-details--loading");
                                    methods.sendRequest.call(this, settings.dataProvider.singleProviderURL, {
                                        "pointID": value["pointID"],
                                        "singleTemplate": settings.singleTemplate
                                    }).done(function (responseData) {
                                        if (responseData["detailsTemplate"] !== undefined) {
                                            settings.container.pointDetails.html(responseData["detailsTemplate"]);

                                            // Show link only when point of sale is not temporary closed
                                            var onMapButton = settings.container.pointDetails.find(".btn-show-on-map");
                                            if (!responseData["temporaryClosed"]) {
                                                if (onMapButton.length > 0) {
                                                    onMapButton.bind("click", function (event) {
                                                        event.preventDefault();

                                                        // Center map on location
                                                        objects.currentMapPlugin.getMap().setView([responseData["lat"], responseData["lng"]], 20);
                                                    });
                                                } else {
                                                    settings.container.pointDetails.append(
                                                        $("<span class='btn btn-outline-success' />").text(settings.translation["Show on the map"]).bind("click", function (event) {
                                                            event.preventDefault();

                                                            // Center map on location
                                                            objects.currentMapPlugin.getMap().setView([responseData["lat"], responseData["lng"]], 20);
                                                        })
                                                    );
                                                }
                                            } else {
                                                if (onMapButton.length > 0) {
                                                    onMapButton.remove();
                                                }
                                            }

                                            settings.container.pointDetails.removeClass("map-point-details--loading");
                                        }
                                    });

                                })
                            );
                        });

                        settings.container.pointChoice.removeClass("map-choice--loading");
                    });
                } else {
                    settings.container.pointChoice.append(
                        $("<section class='map-choice__item' />").text(settings.translation["Please choose a city"])
                    );
                }
            },
            bindOnlinePositionButton: function () {

                // Configure Event Listener
                objects.currentMapPlugin.getMap().on("locationfound", function (e) {
                    var currentLat = e.latitude;
                    var currentLng = e.longitude;

                    methods.sendRequest.call(this, settings.dataProvider.nearestBoundsProviderURL, {
                        "lat": currentLat,
                        "lng": currentLng
                    }).done(function (responseData) {
                        if (Array.isArray(responseData) && responseData.length > 0) {
                            objects.currentMapPlugin.getMap().fitBounds(responseData);
                        } else {
                            $.toast(settings.translation["Unfortunately, there are no points near your location"]);
                        }
                    });
                });

                objects.currentMapPlugin.getMap().on("locationerror", function (e) {
                    $.toast(settings.translation["Unfortunately, we can not determine your location"]);
                });

                // Bind button
                settings.onlinePositionButton.bind("click", function () {
                    objects.currentMapPlugin.getMap().locate();
                });
            },
            bindSearchInput: function () {
                var inputTimer;

                settings.searchInput.bind("input", function () {
                    const _this = $(this);

                    clearTimeout(inputTimer);
                    inputTimer = setTimeout(function () {
                        const searchContent = _this.val();

                        objects.cityAutocomplete.html("");

                        if (searchContent.length > 0) {
                            _this.attr("readonly");

                            methods.sendRequest.call(this, settings.dataProvider.cityAutocompleteProviderURL, {"searchContent": searchContent}).done(function (responseData) {
                                if (Array.isArray(responseData) && responseData.length > 0) {
                                    $.each(responseData, function (index, value) {
                                        objects.cityAutocomplete.append(
                                            $("<section class='autocomplete__item' />").text(value["cityName"] + " (" + value["regionName"] + ")").bind("click", function () {
                                                const regionID = value["regionID"];
                                                const cityName = value["cityName"];
                                                const geoLoc = value["geoLoc"];

                                                // Fill search input with selected city name
                                                settings.searchInput.val(cityName);

                                                // Clear and hide autocomplete
                                                objects.cityAutocomplete.html("");
                                                objects.cityAutocomplete.hide();

                                                // Configure choices
                                                methods.renderCityChoice.call(this, regionID);
                                                methods.renderPointChoice.call(this, regionID, cityName);

                                                // Bounds
                                                objects.currentMapPlugin.getMap().fitBounds(geoLoc);
                                            })
                                        );
                                    });

                                    objects.cityAutocomplete.show();
                                }
                            }).always(function () {
                                _this.removeAttr("readonly");
                                _this.focus();
                            });
                        } else {
                            objects.cityAutocomplete.hide();
                        }
                    }, 1000);
                });
            },
            getCollection: function (requestData) {
                methods.sendRequest.call(this, settings.dataProvider.collectionProviderURL, requestData).done(function (responseData) {
                    objects.currentMapPlugin.geoJSON(responseData);
                });
            },
            getRegionsCollection: function () {
                methods.sendRequest.call(this, settings.dataProvider.regionProviderURL).done(function (responseData) {
                    methods.renderRegionChoice.call(this, responseData);
                });
            },
            sendRequest: function (requestURL, requestData) {
                return $.ajax({
                    method: "POST",
                    url: requestURL,
                    data: $.extend({}, requestData),
                    timeout: 30000
                });
            }
        };

        this.reloadMarkers = function (requestData) {
            objects.currentMapPlugin.removeMarkers();
            methods.getCollection.call(this, requestData);
        };

        return this.each(function () {
            methods.initPlugin.call(this, $(this));
        });
    }
})(jQuery);

(function ($) {
    $.fn.reCaptchaPlugin = function (options) {
        const settings = $.extend({
            reCaptchaSiteKey: null,
            reCaptchaAction: null,
            submitButton: null
        }, options);

        const methods = {
            initPlugin: function (currentObject) {
                methods.registerEventListener.call(this, currentObject);
            },
            registerEventListener: function (currentObject) {
                currentObject.on("submit", function (event) {
                    event.preventDefault();

                    // Disable submit button when specified
                    if (settings.submitButton !== null) {
                        settings.submitButton.attr("disabled", true);
                    }

                    // reCaptcha
                    grecaptcha.ready(function () {
                        grecaptcha.execute(settings.reCaptchaSiteKey, {action: settings.reCaptchaAction}).then(function (token) {
                            currentObject.append('<input type="hidden" name="g-recaptcha-response" value="' + token + '" />');
                            currentObject.append('<input type="hidden" name="g-recaptcha-action" value="' + settings.reCaptchaAction + '" />');

                            // Submit form once again
                            currentObject.unbind("submit").submit();
                        });
                    });
                });
            }
        };

        return this.each(function () {
            methods.initPlugin.call(this, $(this));
        });
    }
})(jQuery);

(function ($) {
    $.extend({
        toast: function (message) {
            const toastContainer = $("<section />").addClass("toast-container").hide().append(
                $("<section />").text(message).addClass("toast-body")
            );

            // Append Toast Container into Body
            $("body").append(toastContainer);

            // Display Toast Container
            toastContainer.fadeIn(500).delay(3000).fadeOut(200, function () {
                $(this).remove();
            });
        }
    });
})(jQuery);

(function ($) {
    $.fn.toggleSwitch = function (options) {
        const settings = $.extend({
            toggleSwitchSelector: "data-toggle",
            toggleHideSelector: "data-toggle-hide",
            toggleShowSelector: "data-toggle-show"
        }, options);

        const objects = {
            currentObject: null,
            toggleHideObject: null,
            toggleShowObject: null
        };

        const methods = {
            /**
             * Initial function
             *
             * @param currentObject
             */
            initModule: function (currentObject) {

                objects.currentObject = currentObject;
                objects.currentObject.bind('click', function () {

                    // Define variable with toggle group
                    const toggleGroup = methods.getToggleGroup.call(this, objects.currentObject, settings);

                    // Find toggleHide & toggleShow objects
                    const toggleHideObject = objects.toggleHideObject = methods.getToggleHideObject.call(this, toggleGroup, settings);
                    const toggleShowObject = objects.toggleShowObject = methods.getToggleShowObject.call(this, toggleGroup, settings);

                    // Animate
                    methods.doAnimation.call(this, currentObject, toggleHideObject, toggleShowObject, settings);
                });

                // Hide all objects that will be display later
                methods.getAllToggleShowObjects.call(this, settings).each(function () {
                    $(this).addClass("hidden");
                });
            },
            /**
             * Function return toggle group name
             *
             * @param currentObject
             * @param settings
             */
            getToggleGroup: function (currentObject, settings) {
                return currentObject.attr(settings.toggleSwitchSelector);
            },
            /**
             * Function return array with toggle show objects
             *
             * @param settings
             * @returns {*|HTMLElement}
             */
            getAllToggleShowObjects: function (settings) {
                return $("*[" + settings.toggleShowSelector + "]");
            },
            /**
             * Function return toggle hide object with specified group name
             *
             * @param toggleGroup
             * @param settings
             * @returns {*|HTMLElement}
             */
            getToggleHideObject: function (toggleGroup, settings) {
                return $("*[" + settings.toggleHideSelector + "='" + toggleGroup + "']");
            },
            /**
             * Function return toggle show object with specified group name
             *
             * @param toggleGroup
             * @param settings
             * @returns {*|HTMLElement}
             */
            getToggleShowObject: function (toggleGroup, settings) {
                return $("*[" + settings.toggleShowSelector + "='" + toggleGroup + "']");
            },
            /**
             * Main animation function
             *
             * @param currentObject
             * @param toggleHideObject
             * @param toggleShowObject
             * @param settings
             */
            doAnimation: function (currentObject, toggleHideObject, toggleShowObject, settings) {
                toggleHideObject.addClass('animated fadeOut').delay(800).queue(function () {
                    $(this).addClass("hidden").dequeue();

                    toggleShowObject.removeClass("hidden").addClass('animated fadeIn');
                });
            }
        };

        return this.each(function () {
            methods.initModule.call(this, $(this));
        });
    }
})(jQuery);

(function ($) {
    $.fn.uploadButtonPlugin = function (options) {
        const settings = $.extend(true, {
            buttonTemplate: "<button type=\"button\" class=\"btn btn-outline-success\"/>",
            descriptionTemplate: "<span/>",
            translation: {
                "Choose a file": "Choose a file",
                "No file selected": "No file selected"
            }
        }, options);

        const objects = {
            currentObject: null,
            parentContainer: null,
            currentButton: null,
            descriptionContainer: null
        };

        const methods = {
            initPlugin: function (currentObject) {
                objects.currentObject = currentObject;
                objects.parentContainer = currentObject.parent();

                // Render and append
                objects.parentContainer.append(
                    objects.currentButton = methods.renderButton.call(this),
                    objects.descriptionContainer = methods.renderDescription.call(this)
                );

                // Listener
                methods.startListener.call(this);
            },
            startListener: function () {
                objects.currentObject.bind("change", function (event) {
                    const selectedFiles = event.target.files;
                    const responseArray = [];

                    if (selectedFiles !== undefined) {
                        for (let i = 0; i < selectedFiles.length; i++) {
                            responseArray.push(selectedFiles.item(i).name);
                        }
                    }

                    objects.descriptionContainer.text(
                        responseArray.join(",")
                    );
                });
            },
            renderButton: function () {
                return $(settings.buttonTemplate).text(settings.translation["Choose a file"]).bind("click", function () {
                    objects.currentObject.click();
                });
            },
            renderDescription: function () {
                return $(settings.descriptionTemplate).text(settings.translation["No file selected"]);
            }
        };

        return this.each(function () {
            methods.initPlugin.call(this, $(this));
        });
    }
})(jQuery);

$(function () {

    const cookiesPolicy = $.p("cookiesPolicy", "template.bundle");
    const ageGate = $.p("ageGate", "template.bundle");

    // Define global constants
    $.extend({
        APP_REQUEST_LOCALE: $.p("requestLocale", "template.bundle")
    });

    // Call initialize functions
    $.initAgeGate(ageGate);
    $.initConsentBar(cookiesPolicy);

    $.initNbsp("p");

    // $.initStickyNavbar($("#navbarContainer"), $("#navbarMargin"));
    $.initBackgroundImage();
    $.initHover();
    $.initNotification();
    $.initAOS();
});

//# sourceMappingURL=template.bundle.js.map
